export default __webpack_public_path__ + "static/media/aip.cc0574ab.jpg";